import { NgModule } from '@angular/core';
import { Route, RouterModule } from '@angular/router';
import { AuthenticatedUserGuard } from '@shared/guards/auth.guard';
import { InstructorResolver } from './client/resolver/instructor.resolver';
import { InstructorCalendarComponent } from './pages/instructor-calendar/instructor-calendar.component';
import { InstructorDetailsComponent } from './pages/instructor-details/instructor-details.component';
import { InstructorRequestCompleteComponent } from './pages/instructor-request-complete/instructor-request-complete.component';
import { InstructorRequestComponent } from './pages/instructor-request/instructor-request.component';
import { InstructorWrapperComponent } from './pages/instructor-wrapper/instructor-wrapper.component';
import { CountryResolver } from '@shared/resolvers/country.resolver';
import { InstructorListComponent } from "./pages/instructor-list/instructor-list.component";
import { InstructorsResolver } from "@modules/instructor/client/resolver/instructors.resolver";
import { AutoLoginPartialRoutesServerSideGuard } from "@core/guards/auto-login-partial-routes-server-side.guard";
import { CategoriesResolver } from '@modules/category/resolvers/categories.resolver';

const routes: Route[] = [
  {
    path: '',
    component: InstructorWrapperComponent,
    children: [
      {
        path: '',
        pathMatch: 'full',
        redirectTo: 'alle'
      },
      {
        path: 'alle',
        component: InstructorListComponent,
        resolve: [InstructorsResolver,CategoriesResolver],
        data: { categoryParams: { isFeatured: true, excludeFalse: false } }
      },
      {
        path: 'soknad',
        component: InstructorRequestComponent,
        canActivate: [AutoLoginPartialRoutesServerSideGuard,AuthenticatedUserGuard],
        resolve: [CountryResolver],
        data: {
          type: 'PERSONAL'
        },
      },
      {
        path: 'profil/:id',
        component: InstructorDetailsComponent,
        resolve: [InstructorResolver, CountryResolver],
      },
      {
        path: 'calendar',
        component: InstructorCalendarComponent,
      },
      {
        path: 'soknad-sendt',
        component: InstructorRequestCompleteComponent,
      },
    ],
  },
];

@NgModule({
  declarations: [],
  exports: [RouterModule],
  imports: [RouterModule.forChild(routes)],
  providers: [],
})
export class GuideRouteModule {}
